<!-- Announcement bar -->
<div class="country-announcement">
  <div class="country-announcement__inner">
    <span class="country-announcement__pill">New</span>
    <span class="country-announcement__text">
      Germany September intake open · save up to <strong>35%</strong> on tuition
    </span>
    <a href="#inquiry" class="country-announcement__cta">
      Claim now
      <span aria-hidden="true">→</span>
    </a>
  </div>
</div>

<!-- Header / Navbar -->
<header class="country-header">
  <div class="country-header__inner">
    <a routerLink="/country1" class="country-logo">
      <span class="country-logo__img-frame">
        <img
          class="country-logo__img"
          src="/assets/images/logo.webp"
          alt=""
          width="200"
          height="52"
        />
      </span>
      <span class="country-logo__wordmark">Careergrad Global</span>
    </a>

    <nav class="country-nav" aria-label="Primary">
      @for (link of navLinks; track link.label) {
        <a [href]="link.href" class="country-nav__link">{{ link.label }}</a>
      }
    </nav>

    <div class="country-header__cta">
      <a href="#inquiry" class="country-btn country-btn--ghost">Book Free Consultation</a>
      <a href="#inquiry" class="country-btn country-btn--primary">Sign Up</a>
    </div>
  </div>
</header>

<!-- Hero -->
<section class="country-hero">
  <div class="country-hero__bg" aria-hidden="true">
    <img
      src="/assets/images/country1/country_hero.jpg"
      alt=""
      loading="eager"
      onerror="this.style.display='none'"
    />
  </div>
  <div class="country-hero__overlay" aria-hidden="true"></div>

  <div class="country-hero__inner">
    <div class="country-hero__copy">
      <div class="country-hero__eyebrow">
        <span class="country-hero__flag" aria-hidden="true">🇩🇪</span>
        <span>Study in Germany</span>
      </div>
      <h1 class="country-hero__title">Study in Germany</h1>
      <p class="country-hero__lede">
        World-class education, zero tuition at public universities, and Europe’s strongest
        job market — Germany is the smart choice for ambitious international students.
      </p>
      <div class="country-hero__actions">
        <a href="#inquiry" class="country-btn country-btn--accent country-btn--lg">Start Your Journey</a>
        <a href="#universities" class="country-btn country-btn--glass country-btn--lg">View Universities</a>
      </div>
    </div>
  </div>
</section>

<!-- Stats -->
<section class="country-stats" aria-label="Key statistics">
  <div class="country-stats__card">
    @for (stat of stats; track stat.label) {
      <div class="country-stat">
        <div class="country-stat__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
               stroke-linecap="round" stroke-linejoin="round" focusable="false">
            @switch (stat.icon) {
              @case ('wallet') {
                <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                <path d="M2 10h20"></path>
              }
              @case ('briefcase') {
                <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                <rect width="20" height="14" x="2" y="6" rx="2"></rect>
              }
              @case ('trending') {
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                <polyline points="16 7 22 7 22 13"></polyline>
              }
              @case ('award') {
                <circle cx="12" cy="8" r="6"></circle>
                <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"></path>
              }
              @default {
                <circle cx="12" cy="8" r="6"></circle>
                <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"></path>
              }
            }
          </svg>
        </div>
        <div class="country-stat__value">{{ stat.value }}</div>
        <div class="country-stat__label">{{ stat.label }}</div>
      </div>
    }
  </div>
</section>

<!-- Why Germany -->
<section class="country-section country-section--cool" id="why">
  <div class="country-container">
    <header class="country-section__head country-section__head--center">
      <span class="country-eyebrow country-eyebrow--lg">Why Choose Germany</span>
      <h2>Your Gateway to Global Excellence</h2>
      <p>
        Affordable degrees, industry-ready skills, and a clear path to stay and work after graduation.
      </p>
    </header>

    <div class="country-why-grid">
      @for (card of whyCards; track card.title) {
        <article class="country-why-card">
          <div class="country-why-card__media">
            <img [src]="'/assets/images/' + card.image" alt="" loading="lazy" decoding="async" />
          </div>
          <div class="country-why-card__overlay" aria-hidden="true"></div>
          <div class="country-why-card__body">
            <h3>{{ card.title }}</h3>
            <p>{{ card.description }}</p>
          </div>
        </article>
      }
    </div>
  </div>
</section>

<!-- Career Grad Global spotlight -->
<section class="country-section country-section--spotlight" aria-label="How Career Grad Global supports your Germany study journey">
  <div class="country-container">
    <div class="country-spotlight">
      <div class="country-spotlight__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
             stroke-linecap="round" stroke-linejoin="round" focusable="false">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="m16.24 7.76-2.12 6.36-6.36 2.12 2.12-6.36 6.36-2.12z"></path>
        </svg>
      </div>
      <p class="country-spotlight__text">
        At Career Grad Global, we help you navigate Germany’s top universities, public funding options,
        and admission processes — ensuring your global journey begins with confidence and clarity.
      </p>
    </div>
  </div>
</section>

<!-- Final CTA + Form (same section as `/home1`) -->
<section class="h1-cta" id="cta">
  <div class="h1-cta__inner">
    <div class="h1-cta__copy">
      <span class="h1-eyebrow h1-eyebrow--on-dark">Ready to begin?</span>
      <h2>
        Take the <span class="h1-cta__highlight">Next Step</span><br />
        of your global career.
      </h2>
      <p>Talk to a senior counselor in 24 hours. No spam, no sales pitch, no upsells — just a clear plan tailored to your goals.</p>
      <ul class="h1-cta__bullets">
        <li><span aria-hidden="true">✓</span> Free 45-minute consultation</li>
        <li><span aria-hidden="true">✓</span> University shortlist within a week</li>
        <li><span aria-hidden="true">✓</span> Scholarship discovery built in</li>
      </ul>
    </div>

    <form class="h1-cta__form" (submit)="$event.preventDefault(); onLeadSubmit()" novalidate>
      <h3>Book a Free Consultation</h3>
      <label>
        <span>Full name</span>
        <input type="text" name="fullName" [(ngModel)]="form.fullName" required placeholder="e.g. Aanya Patel" />
      </label>
      <label>
        <span>Email</span>
        <input type="email" name="email" [(ngModel)]="form.email" required placeholder="you@email.com" />
      </label>
      <label>
        <span>Phone</span>
        <input type="tel" name="phone" [(ngModel)]="form.phone" required placeholder="+91 98765 43210" />
      </label>
      <label>
        <span>Preferred destination</span>
        <select name="destination" [(ngModel)]="form.destination">
          <option value="" disabled selected>Select a country</option>
          <option value="germany">Germany</option>
          <option value="france">France</option>
          <option value="uk">United Kingdom</option>
          <option value="canada">Canada</option>
          <option value="usa">United States</option>
          <option value="australia">Australia</option>
          <option value="ireland">Ireland</option>
          <option value="newzealand">New Zealand</option>
        </select>
      </label>
      <button type="submit" class="h1-btn h1-btn--accent h1-btn--lg h1-btn--block">Request callback</button>
      <p class="h1-cta__small">By submitting you agree to our terms &amp; privacy policy.</p>
    </form>
  </div>
</section>

<!-- Top Universities -->
<section class="country-section country-section--muted" id="universities">
  <div class="country-container">
    <header class="country-section__head">
      <h2>Top-Ranked Universities</h2>
      <p>Explore Germany’s leading public institutions for engineering, sciences and business.</p>
    </header>

    <div class="country-uni-grid">
      @for (uni of universities; track uni.name) {
        <article class="country-uni-card">
          <div class="country-uni-card__media"
               [style.background-image]="'url(/assets/images/country1/' + uni.image + '.jpg)'">
            <span class="country-uni-card__badge">{{ uni.type }}</span>
          </div>
          <div class="country-uni-card__body">
            <h3>{{ uni.name }}</h3>
            <div class="country-uni-card__location">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
                   stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              {{ uni.location }}
            </div>
            <div class="country-uni-card__tags">
              @for (tag of uni.tags; track tag) {
                <span>{{ tag }}</span>
              }
            </div>
            <a href="#" class="country-uni-card__cta">Learn More</a>
          </div>
        </article>
      }
    </div>
  </div>
</section>

<!-- Cost Breakdown -->
<section class="country-costs" id="costs">
  <div class="country-container country-costs__inner">
    <div class="country-costs__copy">
      <h2>Understanding the Costs</h2>
      <p>
        Germany offers exceptional value — plan your finances with clarity before you apply.
        We guide you through tuition, living costs and mandatory insurance.
      </p>
      <ul class="country-costs__list">
        @for (item of costItems; track item.title) {
          <li>
            <div class="country-costs__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
                   stroke-linecap="round" stroke-linejoin="round" focusable="false">
                @switch (item.icon) {
                  @case ('graduation') {
                    <path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"></path>
                    <path d="M22 10v6"></path>
                    <path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"></path>
                  }
                  @case ('home') {
                    <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                  }
                  @default {
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12 2 2 4-4"></path>
                  }
                }
              </svg>
            </div>
            <div>
              <strong>{{ item.title }}</strong>
              <p>{{ item.description }}</p>
            </div>
          </li>
        }
      </ul>
    </div>

    <article class="country-blocked-card">
      <span class="country-blocked-card__badge">Required</span>
      <h3>Blocked Account</h3>
      <p class="country-blocked-card__amount">€11,208 <span>/ year</span></p>
      <p class="country-blocked-card__note">
        Mandatory proof of funds for your student visa. Funds are released monthly once you arrive
        in Germany. We partner with trusted providers for fast setup.
      </p>
    </article>
  </div>
</section>

<!-- Scholarships -->
<section class="country-section country-section--warm" id="scholarships">
  <div class="country-container">
    <header class="country-section__head country-section__head--center">
      <h2>Global Scholarships</h2>
      <p>Funding options to reduce your financial burden and unlock top-tier programs.</p>
    </header>

    <div class="country-scholarship-grid">
      @for (s of scholarships; track s.title) {
        <article class="country-scholarship-card">
          <div class="country-scholarship-card__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
                 stroke-linecap="round" stroke-linejoin="round" focusable="false">
              @if (s.icon === 'globe') {
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
                <path d="M2 12h20"></path>
              } @else {
                <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"></path>
              }
            </svg>
          </div>
          <div>
            <h3>{{ s.title }}</h3>
            <p>{{ s.description }}</p>
            <a href="#" class="country-link country-link--inline">Learn More <span aria-hidden="true">→</span></a>
          </div>
        </article>
      }
    </div>
  </div>
</section>

<!-- Visa Journey -->
<section class="country-visa" id="visa">
  <div class="country-container">
    <header class="country-visa__head">
      <h2>Visa Application Journey</h2>
      <p>
        A structured four-step process from credential verification to your embassy interview.
        We stay with you at every milestone.
      </p>
    </header>

    <ol class="country-timeline">
      <div class="country-timeline__line" aria-hidden="true"></div>
      @for (step of visaSteps; track step.step) {
        <li class="country-timeline__step">
          <div class="country-timeline__node">{{ step.step }}</div>
          <h3>{{ step.title }}</h3>
          <p>{{ step.description }}</p>
        </li>
      }
    </ol>
  </div>
</section>

<!-- FAQ -->
<section class="country-section country-section--warm" id="inquiry">
  <div class="country-container">
    <div class="country-faq country-faq--single">
      <h2>Frequently Asked Questions</h2>
      <div class="country-faq__list">
        @for (faq of faqs; track faq.question; let i = $index) {
          <article class="country-faq-item" [class.is-open]="expandedFaq() === i">
            <button type="button" class="country-faq-item__trigger" (click)="toggleFaq(i)"
                    [attr.aria-expanded]="expandedFaq() === i">
              <span>{{ faq.question }}</span>
              <span class="country-faq-item__icon" aria-hidden="true">
                @if (expandedFaq() === i) { − } @else { + }
              </span>
            </button>
            @if (expandedFaq() === i) {
              <div class="country-faq-item__panel">
                <p>{{ faq.answer }}</p>
              </div>
            }
          </article>
        }
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="country-footer">
  <div class="country-container country-footer__inner">
    <div class="country-footer__brand">
      <a routerLink="/country1" class="country-logo country-logo--on-dark">
        <span class="country-logo__img-frame">
          <img
            class="country-logo__img"
            src="/assets/images/logo.webp"
            alt=""
            width="200"
            height="52"
          />
        </span>
        <span class="country-logo__wordmark">Careergrad Global</span>
      </a>
      <p>
        Helping ambitious students study in Germany with clarity, confidence and the right
        scholarships.
      </p>
      <div class="country-footer__socials" aria-label="Social links">
        <a href="#" aria-label="Facebook">FB</a>
        <a href="#" aria-label="Instagram">IG</a>
        <a href="#" aria-label="LinkedIn">in</a>
      </div>
    </div>

    <div class="country-footer__col">
      <div class="country-footer__heading">Explore</div>
      <ul>
        @for (l of footerExplore; track l.label) {
          <li><a [href]="l.href">{{ l.label }}</a></li>
        }
      </ul>
    </div>

    <div class="country-footer__col">
      <div class="country-footer__heading">Services</div>
      <ul>
        @for (l of footerServices; track l.label) {
          <li><a [href]="l.href">{{ l.label }}</a></li>
        }
      </ul>
    </div>

    <div class="country-footer__col country-footer__newsletter">
      <div class="country-footer__heading">Newsletter</div>
      <p>Subscribe for Germany intake updates, scholarship alerts and visa tips.</p>
      <form class="country-footer__form" (submit)="$event.preventDefault()" novalidate>
        <input type="email" placeholder="Your email address" aria-label="Newsletter email" />
        <button type="submit" class="country-btn country-btn--accent" aria-label="Subscribe">→</button>
      </form>
    </div>
  </div>

  <div class="country-footer__bar">
    <div class="country-container country-footer__bar-inner">
      <span>© 2026 Career Grad. All rights reserved.</span>
      <span>
        <a href="#">Terms</a>
        <span aria-hidden="true">·</span>
        <a href="#">Privacy</a>
        <span aria-hidden="true">·</span>
        <a href="#">Cookies</a>
      </span>
    </div>
  </div>
</footer>
